import { render, staticRenderFns } from "./BrandsLogos.vue?vue&type=template&id=7ebfe4b4&"
import script from "./BrandsLogos.vue?vue&type=script&lang=js&"
export * from "./BrandsLogos.vue?vue&type=script&lang=js&"
import style0 from "./BrandsLogos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports